export default "__VITE_ASSET__B3SVuJ0S__"